import $ from 'jquery';
/* ===============================================================
Woocommerce scripts
=============================================================== */
class NavigationWishlist {
    constructor() {
        // Singleton pattern - return existing instance if it exists
        if (NavigationWishlist.instance) {
            return NavigationWishlist.instance;
        }

        // Get button open
        this.btnOpen = $('.irantheme-woocommerce-wishlist-navigation-open');
        // Get wrapper body
        this.wrapper = $('#irantheme-wrapper');
        // Get irantheme navigation
        this.navigationWishlist = $('.irantheme-woocommerce-cart-navigation');
        // Get wrapper body mask
        this.wrapperMask = $('#irantheme-wrapper-mask');
        // Get wrapper wishlist
        this.wrapperList = this.navigationWishlist.find(
            '.irantheme-woocommerce-wishlist-navigation-wrapper',
        );
        // Get wrapper cart
        this.wrapperCart = this.navigationWishlist.find(
            '.irantheme-woocommerce-cart-navigation-wrapper',
        );
        // Get close button
        this.btnClose = this.navigationWishlist.find(
            '.irantheme-woocommerce-cart-navigation-close',
        );
        this.preloader = this.navigationWishlist.find(
            '.irantheme-preloader-abs',
        );
        this.toggleList = this.navigationWishlist.find(
            '.irantheme-woocommerce-cart-navigation-header-togglers-wishlist',
        );
        this.toggleCart = this.navigationWishlist.find(
            '.irantheme-woocommerce-cart-navigation-header-togglers-cart',
        );

        this.shopName = iranthemeWoo.shopName + '-wishlist';
        this.inWishlist = iranthemeWoo.inWishlist;
        this.restUrl = iranthemeWoo.restUrl;
        this.wishlist = new Array();
        this.ls = sessionStorage.getItem(this.shopName);
        this.userData = '';
        this.loggedIn = $('body').hasClass('logged-in') ? true : false;

        Array.prototype.unique = function () {
            return this.filter(function (value, index, self) {
                return self.indexOf(value) === index;
            });
        };

        this.fetchUsersData();
        this.wishlistToggle();
        this.removeItem();
        this.fetchCount();
        this.events();
    }

    events() {
        this.btnOpen.on('click', () => {
            this.open();
        });
        this.btnClose.on('click', () => {
            this.close();
        });
        this.wrapperMask.on('click', () => {
            this.close();
        });
        this.toggleList.on('click', () => {
            if (!this.toggleList.hasClass('active')) {
                this.toggleList.addClass('active');
                this.toggleCart.removeClass('active');
                // Enable preloader
                this.preloader.addClass('active');
                // Append wishlist fields in navigation
                this.fetchItems();
                setTimeout(() => {
                    this.wrapperCart.hide();
                    this.wrapperList.show();
                }, 1000);
            }
        });

        // ==========================================
        // SYNC LISTENER
        // ==========================================
        // ==========================================
        // SYNC LISTENER
        // ==========================================
        $(document).on(
            'irantheme_wishlist_updated',
            (e, newWishlist, source) => {
                this.wishlist = newWishlist;
                this.fetchCount();
                this.highlightWishlist(this.wishlist, this.inWishlist);

                // Only update the list if:
                // 1. Navigation is open AND
                // 2. The update didn't come from navigation-remove (we already handled it)
                if (
                    this.navigationWishlist.hasClass('active') &&
                    source !== 'navigation-remove'
                ) {
                    this.fetchItems();
                }
            },
        );
    }

    // Toggle nav
    open() {
        this.toggleList.addClass('active');
        this.toggleCart.removeClass('active');
        this.wrapperCart.hide();
        this.wrapperList.show();
        // Enable preloader
        this.preloader.addClass('active');
        this.btnOpen.addClass('active');
        this.navigationWishlist.addClass('active');
        this.wrapperMask.fadeIn();
        // Append wishlist fields in navigation
        this.fetchItems();
    }

    // Close nav
    close() {
        this.btnOpen.removeClass('active');
        this.wrapper.removeClass('active');
        this.navigationWishlist.removeClass('active');
        this.wrapperMask.fadeOut();
    }

    fetchUsersData() {
        let current = this;
        if (current.loggedIn) {
            // Fetch current user data
            $.ajax({
                type: 'POST',
                url: iranthemeWoo.ajaxUrl,
                data: {
                    action: 'fetch_user_data',
                    dataType: 'json',
                },
                success: function (data) {
                    current.userData = JSON.parse(data);
                    if (
                        typeof current.userData['wishlist'] != 'undefined' &&
                        current.userData['wishlist'] != null &&
                        current.userData['wishlist'] != ''
                    ) {
                        var userWishlist = current.userData['wishlist'];
                        userWishlist = userWishlist.split(',');
                        if (current.wishlist.length) {
                            current.wishlist =
                                current.wishlist.concat(userWishlist);
                            $.ajax({
                                type: 'POST',
                                url: iranthemeWoo.ajaxPost,
                                data: {
                                    action: 'user_wishlist_update',
                                    user_id: current.userData['user_id'],
                                    wishlist: current.wishlist.join(','),
                                },
                            });
                        } else {
                            current.wishlist = userWishlist;
                        }
                        current.wishlist = current.wishlist.unique();
                        current.highlightWishlist(
                            current.wishlist,
                            current.inWishlist,
                        );
                        sessionStorage.removeItem(current.shopName);
                    } else {
                        if (
                            typeof current.ls != 'undefined' &&
                            current.ls != null
                        ) {
                            current.ls = current.ls.split(',');
                            current.ls = current.ls.unique();
                            current.wishlist = current.ls;
                        }
                        $.ajax({
                            type: 'POST',
                            url: iranthemeWoo.ajaxPost,
                            data: {
                                action: 'user_wishlist_update',
                                user_id: current.userData['user_id'],
                                wishlist: current.wishlist.join(','),
                            },
                        }).done(function (response) {
                            current.highlightWishlist(
                                current.wishlist,
                                current.inWishlist,
                            );
                            sessionStorage.removeItem(current.shopName);
                        });
                    }
                },
                error: function () {
                    console.log('No user data returned');
                },
            });
        } else {
            if (typeof current.ls != 'undefined' && current.ls != null) {
                current.ls = current.ls.split(',');
                current.ls = current.ls.unique();
                current.wishlist = current.ls;
            }
        }
    }

    isInArray(value, array) {
        return array.indexOf(value) > -1;
    }

    onWishlistComplete(target, title) {
        setTimeout(function () {
            target
                .removeClass('loading')
                .addClass('active')
                .attr('title', title);
        }, 50);
    }

    highlightWishlist(wishlist, title) {
        let current = this;
        $(document)
            .find('.wishlist-toggle')
            .each(function () {
                var $this = $(this);
                var currentProduct = $this.data('product');
                currentProduct = currentProduct.toString();
                if (current.isInArray(currentProduct, wishlist)) {
                    $this.addClass('active').attr('title', title);
                } else {
                    $this.removeClass('active').removeAttr('title');
                }
            });
    }

    wishlistToggle() {
        let current = this;
        $(document)
            .find('.wishlist-toggle')
            .each(function () {
                var $this = $(this);
                var currentProduct = $this.data('product');
                currentProduct = currentProduct.toString();
                if (
                    !current.loggedIn &&
                    current.isInArray(currentProduct, current.wishlist)
                ) {
                    $this.addClass('active').attr('title', current.inWishlist);
                }
                $(this).on('click', function (e) {
                    e.preventDefault();
                    if (
                        !$this.hasClass('active') &&
                        !$this.hasClass('loading')
                    ) {
                        $this.addClass('loading');
                        current.wishlist.push(currentProduct);
                        current.wishlist = current.wishlist.unique();
                        if (current.loggedIn) {
                            // get user ID
                            if (current.userData['user_id']) {
                                $.ajax({
                                    type: 'POST',
                                    url: iranthemeWoo.ajaxPost,
                                    data: {
                                        action: 'user_wishlist_update',
                                        user_id: current.userData['user_id'],
                                        wishlist: current.wishlist.join(','),
                                    },
                                })
                                    .done(function (response) {
                                        current.onWishlistComplete(
                                            $this,
                                            current.inWishlist,
                                        );
                                        // SYNC TRIGGER
                                        $(document).trigger(
                                            'irantheme_wishlist_updated',
                                            [current.wishlist, 'navigation'],
                                        );
                                    })
                                    .fail(function (error) {
                                        console.log(error.responseText);
                                    })
                                    .always(function (data) {
                                        current.fetchCount();
                                    });
                            }
                        } else {
                            sessionStorage.setItem(
                                current.shopName,
                                current.wishlist.toString(),
                            );
                            current.onWishlistComplete(
                                $this,
                                current.inWishlist,
                            );
                            // SYNC TRIGGER
                            $(document).trigger('irantheme_wishlist_updated', [
                                current.wishlist,
                                'navigation',
                            ]);
                        }
                    }
                });
            });
    }

    // Fetch wishlist items
    fetchItems() {
        let current = this;
        if (iranthemeWoo.woocommerceIsActivate == 1) {
            setTimeout(function () {
                // Get admin ajax url
                var ajax_url = iranthemeWpData.adminAjax;
                $.ajax({
                    url: ajax_url,
                    type: 'post',
                    data: {
                        action: 'wishlist_list_items_navigation',
                        wishlist_ids: current.wishlist.join(','),
                    },
                    dataType: 'html',
                    beforeSend: () => {
                        // Empty wrapper list
                        current.wrapperList.html('');
                        current.preloader.addClass('active');
                    },
                    success: (response) => {
                        $(
                            '.irantheme-woocommerce-wishlist-navigation-wrapper',
                        ).html(response);
                    },
                    complete: (response) => {
                        current.preloader.removeClass('active');
                    },
                    error: (error) => {
                        console.log(error.responseText);
                    },
                });
            }, 1000);
        } else {
            // Empty wrapper list
            current.wrapperList.html('');
            let emptyTag =
                '<p class="irantheme-woocommerce-cart-navigation-wrapper-empty">متاسفانه افزونه ووکامرس فعال یا نصب نمی باشد.</p>';
            $(emptyTag).prependTo(current.wrapperList);
            current.preloader.removeClass('active');
        }
    }

    // Count of wishlist items
    fetchCount() {
        let current = this;
        if (iranthemeWoo.woocommerceIsActivate == 1) {
            setTimeout(function () {
                if (current.wishlist.length) {
                    $('.irantheme-wishlist-count').text(
                        current.wishlist.length,
                    );
                    $('.irantheme-wishlist-count').parent().fadeIn();
                } else {
                    $('.irantheme-wishlist-count').text(
                        current.wishlist.length,
                    );
                    $('.irantheme-wishlist-count').parent().fadeOut();
                }
            }, 1000);
        }
    }

    // Remove item from wishlist
    removeItem() {
        let current = this;
        $(document).on('click', '.wishlist-remove', function (e) {
            e.preventDefault();
            e.stopPropagation(); // Prevent event bubbling

            // Get the clicked element and product
            var $this = $(this);
            var productId = $this
                .closest('.irantheme-woocommerce-cart-navigation-list-item')
                .data('product');

            // Remove the item from DOM immediately
            var $itemToRemove = $this.closest(
                '.irantheme-woocommerce-cart-navigation-list-item',
            );
            $itemToRemove.fadeOut(300, function () {
                $(this).remove();

                // Update wishlist array
                var index = current.wishlist.indexOf(productId.toString());
                if (index > -1) {
                    current.wishlist.splice(index, 1);
                }

                // Enable preloader
                current.preloader.addClass('active');

                // Update storage/backend
                if (current.loggedIn && current.userData['user_id']) {
                    $.ajax({
                        type: 'POST',
                        url: iranthemeWoo.ajaxPost,
                        data: {
                            action: 'user_wishlist_update',
                            user_id: current.userData['user_id'],
                            wishlist: current.wishlist.join(','),
                        },
                    })
                        .done(function (response) {
                            // Hide preloader
                            current.preloader.removeClass('active');
                            // SYNC TRIGGER with a small delay to ensure UI is updated
                            setTimeout(function () {
                                $(document).trigger(
                                    'irantheme_wishlist_updated',
                                    [current.wishlist, 'navigation-remove'],
                                );
                            }, 100);
                        })
                        .fail(function (response) {
                            console.log(response.responseText);
                            current.preloader.removeClass('active');
                        })
                        .always(function (data) {
                            current.fetchCount();
                        });
                } else {
                    sessionStorage.setItem(
                        current.shopName,
                        current.wishlist.toString(),
                    );
                    // Hide preloader
                    current.preloader.removeClass('active');
                    // SYNC TRIGGER with a small delay
                    setTimeout(function () {
                        $(document).trigger('irantheme_wishlist_updated', [
                            current.wishlist,
                            'navigation-remove',
                        ]);
                    }, 100);
                }
            });
        });
    }
}

export default NavigationWishlist;
